var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRock1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.5 12 12",
    shapeRendering: "crispEdges",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#394d56",
    d: "M3 2h6M2 3h1m6 0h1M1 4h1m3 0h3m1 0h2M1 5h1m2 0h1M1 6h1m2 0h2M1 7h2M1 8h1M1 9h3m1 0h1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#446675",
    d: "M3 3h6M2 4h3m3 0h1M5 5h3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#2d3e4f",
    d: "M0 5h1m1 0h2m4 0h1M0 6h1m1 0h2m2 0h5M0 7h1m2 0h5m1 0h1M0 8h1m1 0h1m1 0h2m1 0h4M4 9h1m1 0h1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1b2b3a",
    d: "M9 5h3m-1 1h1M8 7h1m1 0h2M3 8h1m2 0h1m4 0h1M0 9h1m6 0h5M1 10h10"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRock1);
export default __webpack_public_path__ + "static/media/rock1.124890090b8adcf2aadc08b2fa8e81a5.svg";
export { ForwardRef as ReactComponent };